"use client";
import React, { useActionState } from "react";
import { faUserCircle } from "@fortawesome/pro-solid-svg-icons";
import Link from "next/link";

import register from "@/actions/register";
import {
  ButtonBar,
  ButtonGroup,
  Main,
  Module,
  PageHeading,
  SubmitButton,
  TextInput,
  ThemedPage,
  UserError,
} from "@/components";
import RecaptchaChallenge from "@/components/recaptcha";

export type RegisterFormState = {
  errors: string[];
};

const initialState: RegisterFormState = {
  errors: [],
};

const RegistrationForm = () => {
  const [state, formAction] = useActionState(register, initialState);

  return (
    <ThemedPage>
      <Main small>
        <PageHeading>Register a new account</PageHeading>
        <Module>
          <p>
            Please enter a few details so that you can retrieve and edit your
            animations in the future. If you already have an account, please{" "}
            <Link href="/sign-in">sign-in</Link>.
          </p>
        </Module>
        <Module>
          <p>Your email address is only used for password reset emails.</p>
        </Module>
        <UserError errors={state.errors} />
        <form action={formAction}>
          <Module>
            <TextInput
              id="username"
              name="username"
              type="text"
              maxLength={30}
              autoCapitalize="none"
              label="User name: (No spaces, alphanumeric, less than 30 chars)"
            />
            <TextInput
              id="email"
              name="email"
              type="email"
              autoCapitalize="none"
              label="Email address:"
            />
            <p>
              This must be a valid email address which can receive emails from
              The Animator. Accounts without verified email addresses cannot
              post animations or comments.
            </p>
            <TextInput
              id="password"
              name="password"
              type="password"
              label="Password: (At least 4 characters)"
            />
            <TextInput
              id="password-confirm"
              name="confirmPassword"
              type="password"
              label="Re-enter password:"
            />
            <RecaptchaChallenge />
          </Module>

          <ButtonBar>
            <ButtonGroup align="right">
              <SubmitButton
                icon={faUserCircle}
                rightAlign
                text="Create a new account"
                submittingText="Registering..."
                testId="register-button"
              />
            </ButtonGroup>
          </ButtonBar>
        </form>
      </Main>
    </ThemedPage>
  );
};

export default RegistrationForm;
